import "./style.less";

export default function repeatableResults() {
    return {
        restrict: "E",
        scope: {
            booking: "=",
            //isCollapsed : '=',
            apiResultCollection: "=",
            selectedWeekRange: "=",
            selectedWeekDays: "=",
        },
        template: require("./template.html"),

        controller: function ($scope, $rootScope, Basket, houseService, Log) {
            let selectedRepeatables = [];
            $scope.selectedRepeatables = selectedRepeatables;

            $scope.selectAll = false;

            $scope.selectRepeatable = function (repeatable) {
                //the checkboxx directive toggles the active state

                if (!repeatable.isUnavailable) {
                    repeatable.active = !repeatable.active;
                }
                if (repeatable.active) {
                    selectedRepeatables.push(repeatable);
                } else {
                    // find same object among selectedRepeatables and save its index. then remove from array

                    var index = 0;

                    selectedRepeatables.forEach((val, key) => {
                        if (repeatable == val) {
                            index = key;
                            // console.log('remove from selected : ' + val.date.format('DD-MM-YYYY') );
                        }
                    });

                    selectedRepeatables.splice(index, 1);
                }

                //console.log($scope.selectedRepeatables);
            };

            $scope.anyAvailableResults = function () {
                var anyAvailable = false;

                $scope.selectAll = false;

                angular.forEach($scope.apiResultCollection, function (item) {
                    if (!item.isUnavailable) {
                        // true
                        anyAvailable = true;
                    }
                });

                $scope.anyAvailable = anyAvailable;
            };

            $scope.selectAllRepeatable = function () {
                if (!$scope.selectAll) {
                    selectedRepeatables.length = 0;

                    // ADD ALL
                    angular.forEach(
                        $scope.apiResultCollection,
                        function (repeatable) {
                            if (!repeatable.isUnavailable) {
                                //if (!repeatable.laneBestFit.allreadyExistInBasket) {
                                $scope.selectAll = true;
                                repeatable.active = true;

                                selectedRepeatables.push(repeatable);
                                //}
                            }
                        }
                    );
                } else {
                    // REMOVE ALL
                    angular.forEach(
                        $scope.apiResultCollection,
                        function (repeatable) {
                            $scope.selectAll = false;
                            repeatable.active = false;
                        }
                    );

                    selectedRepeatables.length = 0;
                }
            };

            $scope.addRepeatablesTobookings = function () {
                $scope.selectAll = false;

                Log.obj(
                    "Conditional : searchFilter : ",
                    houseService.searchFilter.houseCategory
                );
                Log.obj("Conditional : BasketJar activity: ", Basket.activity);

                Log.obj(
                    "Conditional : searchFilter : ",
                    houseService.searchFilter.houseType
                );
                Log.obj("Conditional : BasketJar location: ", Basket.location);

                selectedRepeatables.forEach((repeatableBooking) => {
                    if (repeatableBooking.active) {
                        // console.log('----- REPEATABLE BOOKING :  ');
                        // console.log(repeatableBooking);

                        var allreadyExistInBasket = null;

                        //Is any of the repeatable bookings allready in the basket ?
                        angular.forEach(
                            Basket.currentBookings,
                            function (basketBooking) {
                                if (
                                    basketBooking.Periods[0].UniqueKey ==
                                    repeatableBooking.laneBestFit.period
                                        .UniqueKey
                                ) {
                                    //console.log('Booking is allready in the basket');
                                    allreadyExistInBasket = true;
                                }
                            }
                        );

                        if (!allreadyExistInBasket) {
                            // console.log('add period');

                            // add selected repeatable bookings to currentBookings
                            Basket.addPeriod(
                                repeatableBooking.laneBestFit,
                                repeatableBooking.laneBestFit.period
                            );

                            // Basket.addPeriod(
                            //     repeatableBooking.laneBestFit,
                            //     repeatableBooking.laneBestFit.period
                            // ).then(() => {
                            // });
                        }
                    }
                });

                // reset Selected
                $scope.resetRepeatableResults();

                //close repeatable Bookings collapsable!
                $scope.toogleCollapsible(true);
            };

            $scope.toogleCollapsible = function (bool) {
                $scope.booking.isCollapsed = bool;

                $rootScope.$broadcast("any-repeabable-collapsed", {
                    collapsed: bool,
                });
            };

            // On-load
            $scope.toogleCollapsible(true);

            $scope.resetRepeatableResults = function () {
                $scope.selectedWeekRange = null;
                selectedRepeatables.length = 0;
                $scope.apiResultCollection.length = 0;
            };
        },
    };
}
